import { createReducer, on } from '@ngrx/store';
import { setScatterPlot } from '../scatter-plot.actions';
import { setPresentationOption } from './presentation-options.actions';
import { ScatterPlotPresentationOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
export const note = createReducer('', on(setPresentationOption, (state, action) => {
    if (action.option === ScatterPlotPresentationOptionValue.note) {
        return action.value;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.note;
}));
